import { render, staticRenderFns } from "./UnidadeMedidaList.vue?vue&type=template&id=37a79532&scoped=true"
import script from "./UnidadeMedidaList.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaList.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaList.vue?vue&type=style&index=0&id=37a79532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a79532",
  null
  
)

export default component.exports